// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"ea7fbc2d","359":"ecb3f9eb","401":"061a3bdd","406":"13d7ecb5","488":"4efccabe","617":"98130727","772":"30b05bb2","787":"5af059d1","949":"382e918f","950":"27efc517"}[chunkId] + ".chunk.js";
};